export default __webpack_public_path__ + "static/media/pw.065f4449.svg";